import { ILanguagesCodes } from '@picsart/rc/languages';

export const defaultLanguage = 'en';
export const languageCookieKey = 'language';

export const languagesList = {
  full: {
    zh_Hant: {
      name: 'Chinese (Tr.)',
      nativeName: '',
      value: 'zh_Hant',
    },
    zh: {
      name: 'Chinese (Si.)',
      nativeName: '',
      value: 'zh',
    },
    en: {
      name: 'English',
      nativeName: '',
      value: 'en',
    },
    ru: {
      name: 'Russian',
      nativeName: '',
      value: 'ru',
    },
    de: {
      name: 'German',
      nativeName: '',
      value: 'de',
    },
    es: {
      name: 'Spanish',
      nativeName: '',
      value: 'es',
    },
    hy: {
      name: 'Armenian',
      nativeName: 'Հայերեն',
      value: 'hy',
    },
    bn: {
      name: 'Bengali',
      nativeName: '',
      value: 'bn',
    },
    bg: {
      name: 'Bulgarian',
      nativeName: '',
      value: 'bg',
    },
    hr: {
      name: 'Croatian',
      nativeName: '',
      value: 'hr',
    },
    cs: {
      name: 'Czech',
      nativeName: '',
      value: 'cs',
    },
    da: {
      name: 'Danish',
      nativeName: '',
      value: 'da',
    },
    nl: {
      name: 'Dutch',
      nativeName: '',
      value: 'nl',
    },
    et: {
      name: 'Estonian',
      nativeName: '',
      value: 'et',
    },
    fi: {
      name: 'Finnish',
      nativeName: '',
      value: 'fi',
    },
    fr: {
      name: 'French',
      nativeName: '',
      value: 'fr',
    },
    ka: {
      name: 'Georgian',
      nativeName: '',
      value: 'ka',
    },
    el: {
      name: 'Greek',
      nativeName: '',
      value: 'el',
    },
    hi: {
      name: 'Hindi',
      nativeName: '',
      value: 'hi',
    },
    hu: {
      name: 'Hungarian',
      nativeName: '',
      value: 'hu',
    },
    id: {
      name: 'Indonesian',
      nativeName: '',
      value: 'id',
    },
    it: {
      name: 'Italian',
      nativeName: '',
      value: 'it',
    },
    ja: {
      name: 'Japanese',
      nativeName: '',
      value: 'ja',
    },
    kk: {
      name: 'Kazakh',
      nativeName: '',
      value: 'kk',
    },
    ko: {
      name: 'Korean',
      nativeName: '',
      value: 'ko',
    },
    lv: {
      name: 'Latvian',
      nativeName: '',
      value: 'lv',
    },
    lt: {
      name: 'Lithuanian',
      nativeName: '',
      value: 'lt',
    },
    mk: {
      name: 'Macedonian',
      nativeName: '',
      value: 'mk',
    },
    mn: {
      name: 'Mongolian',
      nativeName: '',
      value: 'mn',
    },
    nb: {
      name: 'Norwegian Bokmål',
      nativeName: '',
      value: 'nb',
    },
    fa: {
      name: 'Persian',
      nativeName: '',
      value: 'fa',
    },
    pl: {
      name: 'Polish',
      nativeName: '',
      value: 'pl',
    },
    pt: {
      name: 'Portuguese',
      nativeName: '',
      value: 'pt',
    },
    ro: {
      name: 'Romanian',
      nativeName: '',
      value: 'ro',
    },
    sr: {
      name: 'Serbian',
      nativeName: '',
      value: 'sr',
    },
    sk: {
      name: 'Slovak',
      nativeName: '',
      value: 'sk',
    },
    sl: {
      name: 'Slovenian',
      nativeName: '',
      value: 'sl',
    },
    sv: {
      name: 'Swedish',
      nativeName: '',
      value: 'sv',
    },
    th: {
      name: 'Thai',
      nativeName: '',
      value: 'th',
    },
    tr: {
      name: 'Turkish',
      nativeName: '',
      value: 'tr',
    },
    uk: {
      name: 'Ukrainian',
      nativeName: '',
      value: 'uk',
    },
    uz: {
      name: 'Uzbek',
      nativeName: '',
      value: 'uz',
    },
    vi: {
      name: 'Vietnamese',
      nativeName: '',
      value: 'vi',
    },
  },
  partly: {
    en: {
      name: 'English',
      nativeName: 'English',
      value: 'en',
    },
    fr: {
      name: 'French',
      nativeName: 'Français',
      value: 'fr',
    },
    de: {
      name: 'German',
      nativeName: 'Deutsch',
      value: 'de',
    },
    id: {
      name: 'Indonesian',
      nativeName: 'Indonesia',
      value: 'id',
    },
    ja: {
      name: 'Japanese',
      nativeName: '日本語',
      value: 'ja',
    },
    pt: {
      name: 'Portuguese (Br.)',
      nativeName: 'português (br.)',
      value: 'pt',
    },
    ru: {
      name: 'Russian',
      nativeName: 'Русский',
      value: 'ru',
    },
    es: {
      name: 'Spanish',
      nativeName: 'Español',
      value: 'es',
    },
    tr: {
      name: 'Turkish',
      nativeName: 'Türkçe',
      value: 'tr',
    },
  },
};

export const languagesCodesListFull: string[] = [
  'zh_HANT',
  'zh',
  'en',
  'ru',
  'de',
  'es',
  'hi',
  'fr',
  'id',
  'it',
  'ja',
  'ko',
  'pl',
  'pt',
  'th',
  'tr',
  'vi',
  'hy',
  'bn',
  'bg',
  'hr',
  'cs',
  'da',
  'nl',
  'et',
  'fi',
  'el',
  'hi-IN',
  'hu',
  'lv',
  'lt',
  'mr',
  'ro',
  'sr',
  'sk',
  'sl',
  'sv',
  'ta',
  'te',
  'uk',
];
export const languagesCodesListPartly: ILanguagesCodes[] = [
  'en',
  'fr',
  'de',
  'id',
  'ja',
  'pt',
  'ru',
  'es',
  'tr',
];
